import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon--svg icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M6.56727 19.5384L7.56727 15.5384H3.75977L4.13477 14.0384H7.94227L8.96152 9.96143H5.15402L5.52902 8.46143H9.33652L10.3365 4.46143H11.8173L10.8173 8.46143H14.952L15.952 4.46143H17.4328L16.4328 8.46143H20.2403L19.8653 9.96143H16.0578L15.0385 14.0384H18.846L18.471 15.5384H14.6635L13.6635 19.5384H12.1828L13.1828 15.5384H9.04802L8.04802 19.5384H6.56727ZM9.42302 14.0384H13.5578L14.577 9.96143H10.4423L9.42302 14.0384Z",
      fill: "#D3D3D3"
    }, null, -1)
  ])))
}
export default { render: render }